import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1172b8ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-content" }

import { computed, inject, PropType, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { PPTAudioElement } from '@/types/slides'
import { injectKeySlideId, injectKeySlideScale } from '@/types/injectKey'
import { VIEWPORT_SIZE } from '@/configs/canvas'

import AudioPlayer from './AudioPlayer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScreenAudioElement',
  props: {
  elementInfo: {
    type: Object as PropType<PPTAudioElement>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { viewportRatio, currentSlide } = storeToRefs(useSlidesStore())

const scale = inject(injectKeySlideScale) || ref(1)
const slideId = inject(injectKeySlideId) || ref('')

const inCurrentSlide = computed(() => currentSlide.value.id === slideId.value)

const audioIconSize = computed(() => {
  return Math.min(props.elementInfo.width, props.elementInfo.height) + 'px'
})
const audioPlayerPosition = computed(() => {
  const canvasWidth = VIEWPORT_SIZE
  const canvasHeight = VIEWPORT_SIZE * viewportRatio.value

  const audioWidth = 280 / scale.value
  const audioHeight = 50 / scale.value

  const elWidth = props.elementInfo.width
  const elHeight = props.elementInfo.height
  const elLeft = props.elementInfo.left
  const elTop = props.elementInfo.top

  let left = 0
  let top = elHeight
  
  if (elLeft + audioWidth >= canvasWidth) left = elWidth - audioWidth
  if (elTop + elHeight + audioHeight >= canvasHeight) top = -audioHeight

  return {
    left: left + 'px',
    top: top + 'px',
  }
})

const audioPlayerRef = ref<typeof AudioPlayer>()
const toggle = () => {
  if (!audioPlayerRef.value) return
  audioPlayerRef.value.toggle()
}

return (_ctx: any,_cache: any) => {
  const _component_IconVolumeNotice = _resolveComponent("IconVolumeNotice")!

  return (_openBlock(), _createElementBlock("div", {
    class: "screen-element-audio",
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
      height: __props.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_IconVolumeNotice, {
          class: "audio-icon",
          style: _normalizeStyle({
            fontSize: _unref(audioIconSize),
            color: __props.elementInfo.color,
          }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle()))
        }, null, 8, ["style"]),
        (_unref(inCurrentSlide))
          ? (_openBlock(), _createBlock(AudioPlayer, {
              key: 0,
              class: "audio-player",
              ref_key: "audioPlayerRef",
              ref: audioPlayerRef,
              style: _normalizeStyle({ ..._unref(audioPlayerPosition) }),
              src: __props.elementInfo.src,
              loop: __props.elementInfo.loop,
              autoplay: __props.elementInfo.autoplay,
              scale: _unref(scale)
            }, null, 8, ["style", "src", "loop", "autoplay", "scale"]))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ], 4))
}
}

})